import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import Button from "react-bootstrap/Button";
import {
    setAIModuleData,
    setAIModuleRequestData,
    setAIModuleSelectedRows,
    setAIModuleType
} from "../../../../_reducers/aiSlice";
import axios from "axios";
import "./aiModule.css";
import {FaArrowDown, FaArrowUp, FaCloud, FaEye, FaFileInvoice, FaRobot} from "react-icons/fa";
import {TbReload} from "react-icons/tb";
import {MdDeselect, MdOutlineCancel} from "react-icons/md";
import {
    aiModuleTemplateTypes,
    formatAIDocumentColor,
    formatAIDocumentStatus,
    formatMasterAIStatus, formatMasterAIStatusColor, vatDeductibleToleranceLabels,
} from "./aiHelper";
import AISaveSaleModal from "./components/aiSaveSaleModal";
import {Badge, Col, Modal, Row, Spinner, Stack} from "react-bootstrap";
import {toast} from "react-toastify";
import AISaveBuyModal from "./components/aiSaveBuyModal";
import {greekMonthOptions} from "../Payroll/Components/constants";
import Dropdown from "../../../primer/Dropdown";
import {
    formatPath,
    getFileNameFromPath,
    getMimeType,
    getParentPath,
    popExtension,
    registerOrSortToOptionsDD
} from "../Cloud/Components/constants";
import moment from "moment";
import {getInvoiceTypeDescription} from "../../../../_data/mydata/salesInvoiceTypes";
import {getCurrentUser, getGreekCurrencyFormat, isEmpty} from "../../../../_helpers/commonFunctions";
import {setAutoPreview, setCurrentPath} from "../../../../_reducers/cloudSlice";
import {openBuyLocal, openCloud, openDocumentBySection, openSaleLocal} from "../../../../_helpers/tabOpeners";
import {LuLogs} from "react-icons/lu";
import Input from "../../../common/Input";
import Pagination from "../../../primer/Pagination";
import {Popconfirm, Popover} from "antd";
import ReportsTemplate from "../../../common/ReportsTemplate";
import StatusSlider from "../../../primer/StatusSlider/StatusSlider";
import {getInvoiceTypesOptions} from "../../../../_helpers/sharedmydata";
import Alert from "react-bootstrap/esm/Alert";
import {CgDanger} from "react-icons/cg";
import AIBatchSettlementModal from "./components/AIBatchSettlementModal";
import AIPrepaidStatementModal from "./components/AIPrepaidStatementModal";

const AIModuleFiles = () => {
    const dispatch = useDispatch();
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const aiSettings = useSelector((state) => state.AI.aiSettings);
    const requestData = useSelector((state) => state.AI.aiModuleRequestData);
    const aiModuleType = useSelector((state) => state.AI.aiModuleType);
    const aiModuleData = useSelector((state) => state.AI.aiModuleData);
    const aiModuleSelectedRows = useSelector((state) => state.AI.aiModuleSelectedRows);
    const tableData = aiModuleData.data;
    const invoiceTypes = [{value: "sendClassification", label: "Προς Χαρακτηρισμό"}, {value: "sendInvoice", label: "Προς Αποστολή"}, ...getInvoiceTypesOptions("all")];
    const [pageChanged, setPageChanged] = useState(false);

    const [aiDoc, setAIDoc] = useState(null);

    const [showSaleModal, setShowSaleModal] = useState(false);
    const [showBuyModal, setShowBuyModal] = useState(false);
    const [showBatchSettlementModal, setShowBatchSettlementModal] = useState(false);
    const [showPrepaidStatementModal, setShowPrepaidStatementModal] = useState(false);

    const [showReprocessModal, setShowReprocessModal] = useState(false);
    const [loadingReprocess, setLoadingReprocess] = useState(false);

    const [showDeclineModal, setShowDeclineModal] = useState(false);
    const [loadingDecline, setLoadingDecline] = useState(false);

    const [loadingData, setLoadingData] = useState(false);
    const [openCloudTab, setOpenCloudTab] = useState(false);

    const [showLogs, setShowLogs] = useState(false);
    const [disableDownloads, setDisableDownloads] = useState(false);

    const [showRegisterModal, setShowRegisterModal] = useState(false);
    const [loadingRegister, setLoadingRegister] = useState(false);

    const [savingSomething, setSavingSomething] = useState(false);
    const [massLoading, setMassLoading] = useState(false);

    const statusesForCheckboxes = [-121, -122, -123, 499, 500, -501];
    const statusesForClickableRows = [499, 500];

    const isAdmin = getCurrentUser()?.userType === "Admin";

    const [showMassReprocessModal, setShowMassReprocessModal] = useState(false);

    const [vatDeductibleSlider, setVatDeductibleSlider] = useState(aiSettings?.vatDeductibleTolerance || 3);

    useEffect(() => {
        if(isEmpty(requestData.month)) {
            const currentYear = Number(moment().format("YYYY"));
            if (Number(company.year) === currentYear) {
                dispatch(setAIModuleRequestData({...requestData, month: moment().month() === 0 ? moment().format("MM") : moment().subtract(1, "month").format("MM"), forceFetch: true}));
            } else {
                dispatch(setAIModuleRequestData({...requestData, month: "12", forceFetch: true}));
            }
        }
    }, [])

    useEffect(() => {
        if (!showReprocessModal) setVatDeductibleSlider(aiSettings?.vatDeductibleTolerance || 3);
        if (!showMassReprocessModal) setVatDeductibleSlider(aiSettings?.vatDeductibleTolerance || 3);
    }, [showReprocessModal, showMassReprocessModal]);

    useEffect(() => {
        if (requestData?.forceFetch) {
            fetchData(false);
        }
    }, [requestData?.forceFetch])

    useEffect(() => {
        if (pageChanged) {
            setPageChanged(false);
            fetchData(true);
        }
    }, [pageChanged])

    useEffect(() => {
        if (openCloudTab) {
            setOpenCloudTab(false);
            dispatch(openCloud(TABS_DATA));
        }
    }, [openCloudTab])

    const fetchData = (fromPagination = false) => {
        setLoadingData(true);
        const reqData = {...requestData, forceFetch: false};
        if (!fromPagination) {
            reqData.page = 1;
            dispatch(setAIModuleRequestData(reqData));
            dispatch(setAIModuleSelectedRows([]));
        }
        axios.post(`${process.env.REACT_APP_API_URL2}/ai/ai-module`, {
            ...reqData,
            company: company.id,
            year: company.year,
        }).then((res) => {
            setLoadingData(false);
            if (res.data.status === "200") {
                dispatch(setAIModuleData(res.data.data));
            }
        }).catch((err) => {
            setLoadingData(false);
            console.log(err);
        })
    }

    const fetchDataForMass = async () => {
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_URL2}/ai/ai-module`, {
                ...requestData,
                page: -1,
                company: company.id,
                year: company.year,
            });
            if (res.data.status === "200") {
                return (res.data.data.data || []).filter((el) => statusesForCheckboxes.includes(el.erp_status));
            }
        } catch (err) {
            console.log(err);
        }
        return [];
    }

    const onSave = (o) => {
        if (savingSomething) return toast.warning("Παρακαλώ περιμένετε να τελειώσει η προηγούμενη καταχώρηση.");
        if (o.documentType === "Πωλήσεις") {
            setAIDoc(o);
            setShowSaleModal(true);
        } else if (o.documentType === "Αγορές & Δαπάνες") {
            setAIDoc(o);
            setShowBuyModal(true);
        } else if (o.documentType === "Τράπεζες" && o?.batchSettlement) {
            setAIDoc(o);
            setShowBatchSettlementModal(true);
        } else if (o.documentType === "Τράπεζες" && o?.prepaidStatement) {
            setAIDoc(o);
            setShowPrepaidStatementModal(true);
        } else {
            setAIDoc(o);
            setShowRegisterModal(true);
        }
    }

    const onFastSave = async (o, fromMass = false) => {
        if (savingSomething) return toast.warning("Παρακαλώ περιμένετε να τελειώσει η προηγούμενη καταχώρηση.");
        if (o.documentType === "Πωλήσεις") {
            await handleSaleSave(o, null, null, fromMass);
        } else if (o.documentType === "Αγορές & Δαπάνες") {
            await handleSaveBuy(o, null, null, fromMass);
        } else {
            await onRegister(o, fromMass);
        }
    }

    const onMassFastSave = async () => {
        if (savingSomething) return toast.warning("Παρακαλώ περιμένετε να τελειώσει η προηγούμενη ενέργεια.");
        setMassLoading(true);
        let rows = aiModuleSelectedRows;
        if (rows.length === 0) rows = await fetchDataForMass();
        for (const aiDoc of rows) {
            await onFastSave(aiDoc, true);
        }
        setMassLoading(false);
        toast.success("Επιτυχής ενέργεια.");
        fetchData(true);
        dispatch(setAIModuleSelectedRows([]));
    }

    const onReprocess = (o) => {
        setAIDoc(o);
        setShowReprocessModal(true);
        if (showSaleModal) setShowSaleModal(false);
        if (showBuyModal) setShowBuyModal(false);
        if (showBatchSettlementModal) setShowBatchSettlementModal(false);
    }

    const onMassReprocess = async (reprocessFiles = false) => {
        if (savingSomething) return toast.warning("Παρακαλώ περιμένετε να τελειώσει η προηγούμενη ενέργεια.");
        setMassLoading(true);
        let rows = aiModuleSelectedRows;
        if (rows.length === 0) rows = await fetchDataForMass();
        for (const aiDoc of rows) {
            await onReprocessDocument(aiDoc, true, reprocessFiles);
        }
        setMassLoading(false);
        setShowMassReprocessModal(false);
        toast.success("Επιτυχής ενέργεια.");
        fetchData(true);
        dispatch(setAIModuleSelectedRows([]));
    }

    const onReprocessDocument = async (aiDoc, fromMass = false, reprocessFile = false) => {
        // reprocessFile: true, will reprocess the whole file, not just characterizations
        setLoadingReprocess(true);
        await axios.post(`${process.env.REACT_APP_API_URL2}/ai/reprocess-document`, {
            company: company.id,
            reprocessFile,
            fileId: aiDoc.fileId,
            index: aiDoc.index,
            vatDeductibleTolerance: vatDeductibleSlider,
        }).then((res) => {
            setLoadingReprocess(false);
            if (res.data.status === "200") {
                setShowReprocessModal(false);
                if (!fromMass) {
                    fetchData(true);
                    toast.success("Επιτυχής αίτημα επαναεπεξεργασίας.");
                }
            } else {
                if (!fromMass) {
                    fetchData(true);
                    toast.error(res.data.message);
                }
            }
        }).catch((err) => {
            setLoadingReprocess(false);
            console.log(err);
            if (!fromMass) toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const onDecline = (o) => {
        if (savingSomething) return toast.warning("Παρακαλώ περιμένετε να τελειώσει η προηγούμενη ενέργεια.");
        setAIDoc(o);
        setShowDeclineModal(true);
        if (showSaleModal) setShowSaleModal(false);
        if (showBuyModal) setShowBuyModal(false);
        if (showBatchSettlementModal) setShowBatchSettlementModal(false);
        if (showPrepaidStatementModal) setShowPrepaidStatementModal(false);
    }

    const onMassDecline = async () => {
        if (savingSomething) return toast.warning("Παρακαλώ περιμένετε να τελειώσει η προηγούμενη ενέργεια.");
        setMassLoading(true);
        let rows = aiModuleSelectedRows;
        if (rows.length === 0) rows = await fetchDataForMass();
        for (const aiDoc of rows) {
            await onDeclineDocument(aiDoc, true);
        }
        setMassLoading(false);
        toast.success("Επιτυχής ενέργεια.");
        fetchData(true);
        dispatch(setAIModuleSelectedRows([]));
    }

    const onDeclineDocument = async (aiDoc, fromMass = false) => {
        setLoadingDecline(true);
        await axios.post(`${process.env.REACT_APP_API_URL2}/ai/decline-document`, {
            company: company.id,
            fileId: aiDoc.fileId,
            index: aiDoc.index,
        }).then((res) => {
            setLoadingDecline(false);
            if (res.data.status === "200") {
                setShowDeclineModal(false);
                if (!fromMass) {
                    fetchData(true);
                    toast.success("Επιτυχής απόρριψη.");
                }
            } else {
                if (!fromMass) toast.error(res.data.message);
            }
        }).catch((err) => {
            setLoadingDecline(false);
            console.log(err);
            if (!fromMass) toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const onCloudShow = (o) => {
        const path = getParentPath(o.filePath);
        dispatch(setCurrentPath(path));
        dispatch(setAutoPreview(getFileNameFromPath(o.filePath)));
        setOpenCloudTab(true);
    }

    const fetchFileAsBlobURL = async (fileName, filePath, attemptConversion = true) => {
        toast.info("Το αρχείο θα ανοίξει σύντομα...");
        try {
            const fetchResp = await axios.post(`${process.env.REACT_APP_API_URL2}/cloud/action`, {
                action: "fetch",
                attemptConversion: String(attemptConversion),
                currentPath: formatPath(filePath),
                company: company.id,
                year: company.year,
            });
            if (fetchResp.data.status === "200") {
                const fromConversion = fetchResp.data.fromConversion;
                const binaryString = atob(fetchResp.data.data);
                const byteArray = new Uint8Array(binaryString.split('').map((char) => char.charCodeAt(0)));
                let mimeType = getMimeType(fileName);
                if (fromConversion) mimeType = "application/pdf";

                const blob = new Blob([byteArray], { type: mimeType });
                let blobUrl = URL.createObjectURL(blob);
                if (popExtension(fileName) === "pdf" || fromConversion) blobUrl += "#navpanes=0&view=Fit";

                return blobUrl;
            } else {
                return null;
            }
        } catch (err) {
            return null;
        }
    }

    const onFileOpen = async (o) => {
        if (disableDownloads) return toast.warning("Παρακαλώ περιμένετε να ανοίξει το προηγούμενο αρχείο.");
        setDisableDownloads(true);
        const blobURL = await fetchFileAsBlobURL(getFileNameFromPath(o.filePath), o.filePath, true);
        if (blobURL) {
            window.open(blobURL, "_blank");
        } else {
            toast.error("Σφάλμα κατά την άντληση αρχείου.");
        }
        setDisableDownloads(false);
        setTimeout(() => {
            URL.revokeObjectURL(blobURL);
        }, 1000)
    }

    const onLogsShow = (o) => {
        setShowLogs(true);
        setAIDoc(o);
    }

    const renderActionButtons = (o) => {
        let arr = [];
        if (o["erp_status"] === 500) {
            arr.push(<div key={"onFastSave"} className={"ai-module-button ai-module-save-style"} title={"Γρήγορη καταχώρηση"} onClick={(e) => {
                e.stopPropagation();
                onFastSave(o)
            }}><FaRobot size={22} /></div>);
            arr.push(<div key={"onReprocess"} className={"ai-module-button ai-module-reprocess-style"} title={"Επαναεπεξεργασία"} onClick={(e) => {
                e.stopPropagation();
                onReprocess(o)
            }}><TbReload size={22} /></div>);
           /* arr.push(<div key={"onSave"} className={"ai-module-button ai-module-save-style"} title={"Προβολή & Καταχώρηση"} onClick={(e) => {
                e.stopPropagation();
                onSave(o)
            }}><FaSave size={22} /></div>); */
            arr.push(<div key={"onDecline"} className={"ai-module-button ai-module-decline-style"} title={"Απόρριψη"} onClick={(e) => {
                e.stopPropagation();
                onDecline(o)
            }}><MdOutlineCancel size={22} /></div>);
        } else if (o["erp_status"] === -501) {
            arr.push(<div key={"onReprocess"} className={"ai-module-button ai-module-reprocess-style"} title={"Επαναεπεξεργασία"} onClick={(e) => {
                e.stopPropagation();
                onReprocess(o)
            }}><TbReload size={22} /></div>);
        } else if ([-121, -122, -123].includes(o["erp_status"])) {
            arr.push(<div key={"onReprocess"} className={"ai-module-button ai-module-reprocess-style"} title={"Επαναεπεξεργασία"} onClick={(e) => {
                e.stopPropagation();
                onReprocess(o)
            }}><TbReload size={22} /></div>);
        } else if (o["erp_status"] === 499) {
            arr.push(<div key={"onReprocess"} className={"ai-module-button ai-module-reprocess-style"} title={"Επαναεπεξεργασία"} onClick={(e) => {
                e.stopPropagation();
                onReprocess(o)
            }}><TbReload size={22} /></div>);
            /*
            arr.push(<div className={"ai-module-button ai-module-save-style"} title={"Γρήγορη καταχώρηση"} onClick={(e) => {
                e.stopPropagation();
                onFastSave(o)
            }}><FaRobot size={22} /></div>);
             */
          /*  arr.push(<div key={"onSave"} className={"ai-module-button ai-module-save-style"} title={"Προβολή & Καταχώρηση"} onClick={(e) => {
                e.stopPropagation();
                onSave(o)
            }}><FaSave size={22} /></div>); */
        }
        if ([-4, -5, -6, -7].includes(o["aiStatus"])) {
            arr.push(<div key={"onReprocess"} className={"ai-module-button ai-module-reprocess-style"} title={"Επαναεπεξεργασία"} onClick={(e) => {
                e.stopPropagation();
                onReprocess(o)
            }}><TbReload size={22} /></div>);
        }
        if (arr.length > 0) arr.push(<br key={"br"}/>);
        if ([1000, 1001].includes(o["erp_status"]) && (!isEmpty(o["document_mark"]) || !isEmpty(o["erp_document"]))) {
            arr.push(<div key={"handleShowExisting"} className={"ai-module-button ai-module-actions-style"} title={"Προβολή Παραστατικού"} onClick={(e) => {
                e.stopPropagation();
                if(o["documentType"] === "Πωλήσεις") {
                    handleShowExistingSale(o);
                } else if (o["documentType"] === "Αγορές & Δαπάνες") {
                    handleShowExistingBuy(o);
                }
            }}><FaFileInvoice size={22} /></div>);
        } else if (o?.documentHooks) {
            if (o.documentHooks?.length === 1) {
                const obj = o.documentHooks[0];
                arr.push(<div key={"handleShowExisting"} className={"ai-module-button ai-module-actions-style"} title={"Προβολή Παραστατικού"} onClick={(e) => {
                    e.stopPropagation();
                    dispatch(openDocumentBySection(obj._id, company.id, obj.section, TABS_DATA));
                }}><FaFileInvoice size={22} /></div>);
            } else if (o.documentHooks?.length > 1) {
                arr.push(
                    <Popover placement={"top"} content={
                        <div style={{maxWidth: "300px", textAlign: "center"}}>
                            Συσχετιζόμενα παραστατικά:
                            <Stack gap={1}>
                                {o.documentHooks.map((hook, idx) => (
                                    <Badge bg={"primary"} key={`${o.fileId}-${idx}`} style={{cursor: "pointer"}} onClick={() => {
                                        dispatch(openDocumentBySection(hook._id, company.id, hook.section, TABS_DATA));
                                    }}>
                                        {hook.label}
                                    </Badge>
                                ))}
                            </Stack>
                        </div>
                    } title={""}>
                        <div key={"handleShowExisting"} className={"ai-module-button ai-module-actions-style"} title={"Προβολή παραστατικών"} onClick={(e) => {
                            e.stopPropagation();
                        }}><FaFileInvoice size={22} />
                        </div>
                    </Popover>
                );
            }
        }
        arr.push(<div key={"onFileOpen"} className={"ai-module-button ai-module-actions-style"} title={"Άνοιγμα αρχείου"} onClick={(e) => {
            e.stopPropagation();
            onFileOpen(o)
        }}><FaEye size={22} /></div>);
        arr.push(<div key={"onCloudShow"} className={"ai-module-button ai-module-actions-style"} title={"Άνοιγμα στο Cloud"} onClick={(e) => {
            e.stopPropagation();
            onCloudShow(o)
        }}><FaCloud size={22} /></div>);
        arr.push(<div key={"onLogsShow"} className={"ai-module-button ai-module-actions-style"} title={"Προβολή καταγραφών"} onClick={(e) => {
            e.stopPropagation();
            onLogsShow(o)
        }}><LuLogs size={22} /></div>);
        return arr;
    }

    const handleFilterChange = (e, type, name) => {
        const prepChange = {};
        if (type === "dd") {
            prepChange[name] = e.value;
        } else if (type === "msdd") {
            prepChange[name] = e.flatMap((o) => o.value);
        } else if (type === "input") {
            if (name === "scoreFrom" || name === "scoreTo") {
                prepChange[name] = (isEmpty(e.target.value) || isNaN(+e.target.value)) ? "" : +e.target.value;
            } else {
                prepChange[name] = e.target.value;
            }
        }
        dispatch(setAIModuleRequestData({...requestData, ...prepChange}));
    }

    const statusOptions = [
        {label: "Καταχωρημένο", value: "complete"},
        {label: "Αναμονή ενέργειας χρήστη", value: "waiting_user"},
        {label: "Επεξεργασία από AI", value: "pending"},
        {label: "Απόρριψη από χρήστη", value: "declined"},
        {label: "Σφάλμα", value: "error"},
    ]

    const renderExtraData = (o) => {
        const mdType = o?.myDataType ? getInvoiceTypeDescription(o.myDataType) : null;
        const total = o?.totals?.totalValue || 0;
        if (o.documentType === "Πωλήσεις") {
            return (
                <div>
                    {mdType && (
                        <span title={mdType}>{mdType} {moment(o?.date, "DD/MM/YYYY").isValid() ? o.date : ""}</span>
                    )}
                    {!isEmpty(o.numbering) && (
                        <React.Fragment>
                            <br/>
                            Αρίθμηση : <span style={{fontWeight: "600"}}>{o["numbering"]}</span> , ποσό <strong>{getGreekCurrencyFormat(total)}</strong>
                        </React.Fragment>
                    )}
                </div>
            )
        } else if (o.documentType === "Αγορές & Δαπάνες") {
            return (
                <div>
                    {mdType && (
                        <span title={mdType}>{mdType} {moment(o?.date, "DD/MM/YYYY").isValid() ? o.date : ""}</span>
                    )}
                    {!isEmpty(o.numbering) && (
                        <React.Fragment>
                            <br/>
                            Αρίθμηση : <span style={{fontWeight: "600"}}>{o["numbering"]}</span> , ποσό <strong>{getGreekCurrencyFormat(total)}</strong>
                        </React.Fragment>
                    )}
                </div>
            )
        } else {
            return <span>-</span>
        }
    }

    const renderClientSupplier = (o) => {
        if (o.documentType === "Πωλήσεις") {
            return (
                <div>
                    {o.clientName && (
                        <React.Fragment>
                            <span style={{fontWeight: "600"}}>Πελάτης: </span><span title={o.clientName} className={"two-lines"}>{o.clientName}</span>
                        </React.Fragment>
                    )}
                    <span style={{fontWeight: "600"}}>ΑΦΜ: </span><span>{o.clientVATNumber}</span>
                </div>
            )
        } else if (o.documentType === "Αγορές & Δαπάνες") {
            return (
                <div>
                    {o.supplierName && (
                        <React.Fragment>
                            <span style={{fontWeight: "600"}}>Προμηθευτής: </span><span title={o.supplierName} className={"two-lines"}>{o.supplierName}</span>
                        </React.Fragment>
                    )}
                    <span style={{fontWeight: "600"}}>ΑΦΜ: </span><span>{o.supplierVATNumber}</span>
                </div>
            )
        } else {
            return <span>-</span>
        }
    }

    const handleShowExistingBuy = (invoice) => {
        if (invoice?.erp_document) {
            axios.get(process.env.REACT_APP_API_URL2 + "/company/get-document-by-id", {
                headers: { 'Content-Type': 'application/json' },
                params: {
                    company: company.id,
                    docId: invoice.erp_document,
                    section: "Buys",
                }
            }).then((res) => {
                if (res.data.status === "200") {
                    if (res.data.data) {
                        dispatch(openBuyLocal(res.data.data, TABS_DATA));
                    } else {
                        toast.error("Σφάλμα κατά την φόρτωση της αγοράς.");
                    }
                } else {
                    toast.error(res.data.message);
                }
            }).catch((err) => {
                console.log(err);
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            })
        } else if (invoice.document_mark) {
            axios.get(process.env.REACT_APP_API_URL2 + "/buy/get-buy-by-mark", {
                headers: { 'Content-Type': 'application/json' },
                params: {
                    company: company.id,
                    mark: invoice.document_mark,
                }
            }).then((res) => {
                if (res.data.status === "200") {
                    if (res.data.data) {
                        dispatch(openBuyLocal(res.data.data, TABS_DATA));
                    } else {
                        toast.error("Σφάλμα κατά την φόρτωση της αγοράς.");
                    }
                } else {
                    toast.error(res.data.message);
                }
            }).catch((err) => {
                console.log(err);
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            })
        } else {
            toast.error("Σφάλμα κατά την εύρεση του ΜΑΡΚ.");
        }
    }

    const handleShowExistingSale = (invoice) => {
        if (invoice?.erp_document) {
            axios.get(process.env.REACT_APP_API_URL2 + "/company/get-document-by-id", {
                headers: { 'Content-Type': 'application/json' },
                params: {
                    company: company.id,
                    docId: invoice.erp_document,
                    section: "Sales",
                }
            }).then((res) => {
                if (res.data.status === "200") {
                    if (res.data.data) {
                        dispatch(openSaleLocal(res.data.data, TABS_DATA));
                    } else {
                        toast.error("Σφάλμα κατά την φόρτωση της αγοράς.");
                    }
                } else {
                    toast.error(res.data.message);
                }
            }).catch((err) => {
                console.log(err);
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            })
        } else if (invoice.document_mark) {
            axios.get(process.env.REACT_APP_API_URL2 + "/sale/get-sale-by-mark", {
                headers: { 'Content-Type': 'application/json' },
                params: {
                    company: company.id,
                    mark: invoice.document_mark,
                }
            }).then((res) => {
                if (res.data.status === "200") {
                    if (res.data.data) {
                        dispatch(openSaleLocal(res.data.data, TABS_DATA));
                    } else {
                        toast.error("Σφάλμα κατά την φόρτωση της αγοράς.");
                    }
                } else {
                    toast.error(res.data.message);
                }
            }).catch((err) => {
                console.log(err);
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            })
        } else {
            toast.error("Σφάλμα κατά την εύρεση του ΜΑΡΚ.");
        }
    }

    const onRegister = async (aiDoc, fromMass = false) => {
        setSavingSomething(true);
        setLoadingRegister(true);
        await axios.post(`${process.env.REACT_APP_API_URL2}/cloud/action`, {
            action: "emronRegister",
            currentPath: aiDoc.filePath,
            option: aiDoc.documentType,
            company: company.id,
            year: company.year,
        }).then((res) => {
            if (res.data.status === "200") {
                setShowRegisterModal(false);
                if (!fromMass) {
                    fetchData(true);
                    toast.success("Επιτυχής καταχώρηση.");
                }
            } else {
                toast.error(res.data.message);
            }
            setLoadingRegister(false);
            setSavingSomething(false);
        }).catch((err) => {
            setSavingSomething(false);
            setLoadingRegister(false);
            console.log(err);
            if (!fromMass) toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const onPageChange = (page) => {
        setPageChanged(true);
        dispatch(setAIModuleRequestData({...requestData, page}));
    }

    const handleSort = (sortBy) => {
        let sortType;
        if (requestData.sortBy === sortBy) {
            if (requestData.sortType === "1") {
                sortType = "-1";
            } else if (requestData.sortType === "-1") {
                sortType = "";
            } else {
                sortType = "1";
            }
        } else {
            sortType = "1";
        }
        setPageChanged(true);
        dispatch(setAIModuleRequestData({...requestData, sortBy, sortType}))
    }

    const renderSortArrow = (sortBy) => {
        if (requestData.sortBy === sortBy) {
            if (requestData.sortType === "1") {
                return <React.Fragment><FaArrowDown /></React.Fragment>
            } else if (requestData.sortType === "-1") {
                return <React.Fragment><FaArrowUp /></React.Fragment>
            }
        }
        return <React.Fragment></React.Fragment>
    }

    const handleSaleSave = async (aiDoc, saleObject, setLoading, fromMass = false) => {
        if (saleObject?.products && saleObject.products.some((el) => isEmpty(el.name))) return toast.error("Παρακαλώ επιλέξτε είδη σε όλες τι γραμμές παραστατικού.");
        setSavingSomething(true);
        if (setLoading) setLoading(true);
        await axios.post(`${process.env.REACT_APP_API_URL2}/ai/accept-document`, {
            company: company.id,
            fileId: aiDoc.fileId,
            index: aiDoc.index,
            document: saleObject,
        }, {
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            setSavingSomething(false);
            if (setLoading) setLoading(false);
            if (res.data.status === "200") {
                setShowSaleModal(false);
                if (!fromMass) {
                    fetchData(true);
                    toast.success("Επιτυχής καταχώρηση.");
                }
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setSavingSomething(false);
            if (setLoading) setLoading(false);
            console.log(err);
            if (!fromMass) toast.error("Σφάλμα κατά την άντληση εγγραφής.");
        })
    }

    const handleSaveBuy = async (aiDoc, buyObject, setLoading, fromMass = false) => {
        if (buyObject?.products && buyObject.products.some((el) => isEmpty(el.name))) return toast.error("Παρακαλώ επιλέξτε είδη σε όλες τι γραμμές παραστατικού.");

        setSavingSomething(true);
        if (setLoading) setLoading(true);
        await axios.post(`${process.env.REACT_APP_API_URL2}/ai/accept-document`, {
            company: company.id,
            fileId: aiDoc.fileId,
            index: aiDoc.index,
            document: buyObject,
        }, {
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            setSavingSomething(false);
            if (setLoading) setLoading(false);
            if (res.data.status === "200") {
                setShowBuyModal(false);
                if (!fromMass) {
                    fetchData(true);
                    toast.success("Επιτυχής καταχώρηση.");
                }
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setSavingSomething(false);
            if (setLoading) setLoading(false);
            console.log(err);
            if (!fromMass) toast.error("Σφάλμα κατά την άντληση εγγραφής.");
        })
    }

    const handleSaveBatchSettlement = async (aiDoc, batchObject, setLoading, fromMass = false) => {
        if (batchObject?.transactions?.some((el) => isEmpty(el.client) || isEmpty(el.clientName))) {
            return toast.error("Παρακαλώ επιλέξτε πελάτη σε όλες τις συναλλαγές.");
        }
        setSavingSomething(true);
        if (setLoading) setLoading(true);

        await axios.post(`${process.env.REACT_APP_API_URL2}/ai/accept-document`, {
            company: company.id,
            fileId: aiDoc.fileId,
            index: aiDoc.index,
            document: batchObject,
        }, {
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            setSavingSomething(false);
            if (setLoading) setLoading(false);
            if (res.data.status === "200") {
                setShowBatchSettlementModal(false);
                if (!fromMass) {
                    fetchData(true);
                    toast.success("Επιτυχής καταχώρηση.");
                }
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setSavingSomething(false);
            if (setLoading) setLoading(false);
            console.log(err);
            if (!fromMass) toast.error("Σφάλμα κατά την άντληση εγγραφής.");
        })
    }

    const handleSavePrepaidStatement = async (aiDoc, prepaidObject, setLoading, fromMass = false) => {
        if (prepaidObject?.transactions?.some((el) => isEmpty(el.supplier) || isEmpty(el.supplierName))) {
            return toast.error("Παρακαλώ επιλέξτε προμηθευτή σε όλες τις συναλλαγές.");
        }
        setSavingSomething(true);
        if (setLoading) setLoading(true);

        await axios.post(`${process.env.REACT_APP_API_URL2}/ai/accept-document`, {
            company: company.id,
            fileId: aiDoc.fileId,
            index: aiDoc.index,
            document: prepaidObject,
        }, {
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            setSavingSomething(false);
            if (setLoading) setLoading(false);
            if (res.data.status === "200") {
                setShowPrepaidStatementModal(false);
                if (!fromMass) {
                    fetchData(true);
                    toast.success("Επιτυχής καταχώρηση.");
                }
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setSavingSomething(false);
            if (setLoading) setLoading(false);
            console.log(err);
            if (!fromMass) toast.error("Σφάλμα κατά την άντληση εγγραφής.");
        })
    }

    const handleSelectionChange = (e, aiDoc) => {
        e.stopPropagation();
        if (e.target.checked) {
            dispatch(setAIModuleSelectedRows([...aiModuleSelectedRows, aiDoc]));
        } else {
            dispatch(setAIModuleSelectedRows(aiModuleSelectedRows.filter((el) => !(el.fileId === aiDoc.fileId && el.index === aiDoc.index))));
        }
    }

    const renderMassActions = () => {
        return (
            <div>
                {(aiModuleSelectedRows.length > 0 || (aiModuleData.massRegisterApplicable || aiModuleData.massDeclineApplicable || aiModuleData.massDeclineApplicable)) && (
                    <div className={"text-muted"} style={{fontStyle: "italic", textDecoration: "underline", textDecorationStyle: "dotted"}}
                         title={"Κάθε μαζική ενέργεια εφαρμόζεται μόνο στις εγγραφές που είναι πραγματοποιήσιμη"}
                    >
                        Μαζικές Ενέργειες
                    </div>
                )}
                {aiModuleSelectedRows.length > 0 ? (
                    <div>
                        Έχετε επιλέξει {aiModuleSelectedRows.length} {aiModuleSelectedRows.length === 1 ? "γραμμή" : "γραμμές"}
                        <Popconfirm
                            title={"Καταχώρηση επιλεγμένων"}
                            description={"Είσαστε σίγουροι ότι θέλετε να καταχωρήσετε τις επιλογές σας;"}
                            onConfirm={() => onMassFastSave()}
                            okText={"Ναι"}
                            cancelText={"Όχι"}
                        >
                            <div className={"ai-module-button ai-module-save-style ml-2 pr-2"} title={"Καταχώρηση επιλεγμένων"}><FaRobot size={22} /> Καταχώρηση επιλεγμένων</div>
                        </Popconfirm>
                        <div
                            className={"ai-module-button ai-module-reprocess-style ml-2 pr-2"}
                            title={"Επαναεπεξεργασία επιλεγμένων"}
                            onClick={() => setShowMassReprocessModal(true)}
                        >
                            <TbReload size={22} />
                            Επαναεπεξεργασία επιλεγμένων
                        </div>
                        <Popconfirm
                            title={"Απόρριψη επιλεγμένων"}
                            description={"Είσαστε σίγουροι ότι θέλετε να απορρίψετε οι επιλογές σας;"}
                            onConfirm={() => onMassDecline()}
                            okText={"Ναι"}
                            cancelText={"Όχι"}
                        >
                            <div className={"ai-module-button ai-module-decline-style ml-2 pr-2"} title={"Απόρριψη επιλεγμένων"}><MdOutlineCancel size={22} /> Απόρριψη επιλεγμένων</div>
                        </Popconfirm>
                        <div className={"ai-module-button ai-module-reprocess-style ml-2 pr-2"} title={"Αποεπιλογή"} onClick={() => {
                            dispatch(setAIModuleSelectedRows([]));
                        }}><MdDeselect size={22} /> Αποεπιλογή όλων</div>
                    </div>
                ) : (
                    <div>
                        {aiModuleData.massRegisterApplicable && (
                            <Popconfirm
                                title={"Καταχώρηση όλων"}
                                description={"Είσαστε σίγουροι ότι θέλετε να καταχωρήσετε όλες τις διαθέσιμες επιλογές;"}
                                onConfirm={() => onMassFastSave()}
                                okText={"Ναι"}
                                cancelText={"Όχι"}
                            >
                                <div className={"ai-module-button ai-module-save-style pr-2"} title={"Γρήγορη Καταχώρηση όλων"}><FaRobot size={22} /> Καταχώρηση όλων</div>
                            </Popconfirm>
                        )}
                        {aiModuleData.massReprocessApplicable && (
                            <div
                                className={"ai-module-button ai-module-reprocess-style ml-2 pr-2"}
                                title={"Επαναεπεξεργασία όλων"}
                                onClick={() => setShowMassReprocessModal(true)}
                            >
                                <TbReload size={22} />
                                Επαναεπεξεργασία όλων
                            </div>
                        )}
                        {aiModuleData.massDeclineApplicable && (
                            <Popconfirm
                                title={"Απόρριψη όλων"}
                                description={"Είσαστε σίγουροι ότι θέλετε να απορρίψετε όλες οι διαθέσιμες επιλογές;"}
                                onConfirm={() => onMassDecline()}
                                okText={"Ναι"}
                                cancelText={"Όχι"}
                            >
                                <div className={"ai-module-button ai-module-decline-style ml-2 pr-2"} title={"Απόρριψη όλων"}><MdOutlineCancel size={22} /> Απόρριψη όλων</div>
                            </Popconfirm>
                        )}
                    </div>
                )}
            </div>
        )
    }

    return (
        <React.Fragment>
            <ReportsTemplate templateType={"ai-module"}
                             requestData={requestData}
                             fetchReport={() => fetchData(false)}
                             setRequestData={(data) => dispatch(setAIModuleRequestData(data))}
                             header={"Ανάλυση αρχείων - Primer AI"}
            />
            <div onKeyDown={(e) => {
                if (e?.key === "Enter") fetchData(false);
            }}>
                <Row className={"mb-2"}>
                    <Col md={2}>
                        <Dropdown
                            name={"aiModuleType"}
                            label={"Κανάλι AI"}
                            options={aiModuleTemplateTypes}
                            defaultValue={aiModuleTemplateTypes.find((el) => el.value === aiModuleType)}
                            onChange={(e) => dispatch(setAIModuleType(e.value))}
                        />
                    </Col>
                    <Col md={2}>
                        <Dropdown
                            name={"month"}
                            label={"Μήνας"}
                            options={greekMonthOptions}
                            defaultValue={greekMonthOptions.find((el) => el.value === requestData.month)}
                            onChange={(e) => handleFilterChange(e, "dd", "month")}
                        />
                    </Col>
                    <Col md={2}>
                        <Dropdown
                            name={"fileType"}
                            label={"Τύπος αρχείου"}
                            multiSelect={true}
                            options={registerOrSortToOptionsDD}
                            defaultValue={registerOrSortToOptionsDD.filter((el) => requestData.fileType.includes(el.value))}
                            onChange={(e) => handleFilterChange(e, "msdd", "fileType")}
                        />
                    </Col>
                    <Col md={3}>
                        <Dropdown
                            name={"status"}
                            label={"Κατάσταση αρχείου"}
                            multiSelect={true}
                            options={statusOptions}
                            defaultValue={statusOptions.filter((el) => requestData.status.includes(el.value))}
                            onChange={(e) => handleFilterChange(e, "msdd", "status")}
                        />
                    </Col>
                    <Col md={3}>
                        <Input
                            name={"fileName"}
                            type={"text"}
                            label={"Όνομα αρχείου"}
                            value={requestData.fileName}
                            onChange={(e) => handleFilterChange(e, "input", "fileName")}
                        />
                    </Col>
                </Row>
                <Row className={"mb-2"}>
                    <Col md={3}>
                        <Dropdown
                            name={"invoiceType"}
                            label={"Τύπος Παραστατικού"}
                            multiSelect={true}
                            value={requestData.invoiceType}
                            options={invoiceTypes}
                            defaultValue={invoiceTypes.filter((el) => requestData.invoiceType.includes(el.value))}
                            onChange={(e) => handleFilterChange(e, "msdd", "invoiceType")}
                        />
                    </Col>
                    <Col md={5}>
                        <Input
                            name={"general"}
                            type={"text"}
                            label={"Γενικό φίλτρο"}
                            value={requestData.general}
                            placeholder={"Φιλτράρετε κατά αρίθμηση/αντισυμβαλλόμενο κτλπ..."}
                            onChange={(e) => handleFilterChange(e, "input", "general")}
                        />
                    </Col>
                    <Col md={2}>
                        <Input
                            name={"scoreFrom"}
                            type={"number"}
                            label={"Βαθμολογία από"}
                            value={requestData.scoreFrom}
                            onChange={(e) => handleFilterChange(e, "input", "scoreFrom")}
                        />
                    </Col>
                    <Col md={2}>
                        <Input
                            name={"scoreTo"}
                            type={"number"}
                            label={"Βαθμολογία έως"}
                            value={requestData.scoreTo}
                            onChange={(e) => handleFilterChange(e, "input", "scoreTo")}
                        />
                    </Col>
                </Row>
            </div>
            <Row className={"mb-2"}>
                <Col md={6}>
                    {aiModuleData?.unClassifiedMonths?.length > 0 && (
                        <Alert style={{ padding: "0.5rem", marginBottom: "10px" }} variant="danger">
                            <CgDanger size={25} />{" "}
                            <span style={{ fontWeight: "bold" }}>ΠΡΟΣΟΧΗ! Έχετε μη καταχωρημένα αρχεία σε παλαιότερους μήνες!</span>
                            <div style={{ marginTop: "5px", paddingLeft: "35px" }}>
                                {aiModuleData.unClassifiedMonths.map((el, index) => (
                                    <div key={`unclassified_month_${index}`}>
                                        Μήνας: <strong>{el?.month}</strong> — Πλήθος:{" "}
                                        <strong>{el?.count}</strong>
                                    </div>
                                ))}
                            </div>
                        </Alert>
                    )}
                </Col>
                <Col md={6} className="d-flex justify-content-end align-items-end">
                    <Button className="btn btn-primary float-right" onClick={() => fetchData()} disabled={loadingData}>
                        Εφαρμογή Φίλτρων & Αναζήτηση {loadingData && <Spinner className={"ml-1"} animation="border" variant="dark" />}
                    </Button>
                </Col>
            </Row>
            {aiModuleData.totalPages > 0 && (
                <React.Fragment>
                    <Row>
                        <Col md={8} className={"mb-2"}>
                            {renderMassActions()}
                        </Col>
                        <Col md={4} className={"d-flex justify-content-end"}>
                            <div className="mr-md-3 mt-2 mb-2 mb-md-0 text-center text-md-right">
                                <i style={{ whiteSpace: 'nowrap' }}>
                                    Σύνολο Αποτελεσμάτων: {aiModuleData.totalRows}
                                </i>
                            </div>
                            <div className="d-flex justify-content-center justify-content-md-end">
                                <Pagination
                                    currentPage={requestData.page}
                                    totalPages={aiModuleData.totalPages}
                                    handlePageChange={(page) => onPageChange(page)}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className={"mb-3"}>
                        <Col md={12}>
                            <table className={"ai-module-table"}>
                                <colgroup>
                                    <col style={{ width: "3%" }} />
                                    <col style={{ width: "10%" }} />
                                    <col style={{ width: "10%" }} />
                                    <col style={{ width: "20%" }} />
                                    <col style={{ width: "20%" }} />
                                    <col style={{ width: "20%" }} />
                                    <col style={{ width: "15%" }} />
                                    <col style={{ width: "7%" }} />
                                    {isAdmin && <col style={{ width: "3%" }} />}
                                    <col style={{ width: "10%" }} />
                                </colgroup>
                                <thead>
                                <tr>
                                    <th></th>
                                    <th>Κατ/ρία-Ημ/νια μεταφόρτωσης</th>
                                    <th>Μήνας</th>
                                    <th style={{cursor: "pointer"}} onClick={() => handleSort("fileName")}>Αρχείο {renderSortArrow("fileName")}</th>
                                    <th>Δεδομένα Παραστατικού</th>
                                    <th>Δεδομένα Αντισυμβαλλόμενου</th>
                                    <th style={{cursor: "pointer"}} onClick={() => handleSort("status")}>Κατάσταση {renderSortArrow("status")}</th>
                                    <th style={{cursor: "pointer"}} onClick={() => handleSort("score")}>Βαθμολογία {renderSortArrow("score")}</th>
                                    {isAdmin && (
                                        <th style={{cursor: "pointer"}} onClick={() => handleSort("credits")}>Credits {renderSortArrow("credits")}</th>
                                    )}
                                    <th>Ενέργειες</th>
                                </tr>
                                </thead>
                                <tbody>
                                {tableData.length === 0 ? (
                                    <tr>
                                        <td colSpan={9}>Δεν βρέθηκαν δεδομένα.</td>
                                    </tr>
                                ) : tableData.length > 0 ? tableData.map((o, idx) => {
                                    if (o?.unprocessed) {
                                        return (
                                            <tr className={"hover-status"} key={`aim-${idx}`}>
                                                <td></td>
                                                <td>
                                                    {moment(o["created_at"]).format("DD/MM/YYYY HH:mm")}
                                                </td>
                                                <td>{o["month"]}</td>
                                                <td className={"file-name-cell"} title={o["fileLabel"]}>{o["fileLabel"]}</td>
                                                <td>{renderExtraData(o)}</td>
                                                <td>{renderClientSupplier(o)}</td>
                                                <td className={`status-td ${formatMasterAIStatusColor(o["aiStatus"])}`} style={{fontWeight: "600", letterSpacing: "0.3px", borderRadius: "6px"}}>
                                                    {formatMasterAIStatus(o["aiStatus"])}
                                                </td>
                                                <td>{o["erp_score"] || "-"} {o["erp_score"] ? "%" : ""}</td>
                                                {isAdmin && (
                                                    <td>{o["credits"]}</td>
                                                )}
                                                <td>{renderActionButtons(o)}</td>
                                            </tr>
                                        )
                                    } else {
                                        return (
                                            <tr className={"hover-status"} key={`aim-${idx}`}
                                                style={{cursor: statusesForClickableRows.includes(o.erp_status) ? "pointer" : ""}}
                                                onClick={() => {
                                                    const selection = window.getSelection();
                                                    if (selection && selection.toString().length > 0) return;
                                                    if (statusesForClickableRows.includes(o.erp_status)) onSave(o);
                                                }}
                                                onDoubleClick={() => {
                                                    if ([1000, 1001].includes(o["erp_status"]) && (!isEmpty(o["document_mark"]) || !isEmpty(o["erp_document"]))) {
                                                        if(o["documentType"] === "Πωλήσεις") {
                                                            handleShowExistingSale(o);
                                                        } else if (o["documentType"] === "Αγορές & Δαπάνες") {
                                                            handleShowExistingBuy(o);
                                                        }
                                                    } else if (o?.documentHooks && o.documentHooks?.length === 1) {
                                                        const obj = o.documentHooks[0];
                                                        dispatch(openDocumentBySection(obj._id, company.id, obj.section, TABS_DATA));
                                                    }
                                                }}
                                            >
                                                <td>
                                                    {statusesForCheckboxes.includes(o.erp_status) && (
                                                        <input
                                                            type={"checkbox"}
                                                            checked={aiModuleSelectedRows.some((el) => el.fileId === o.fileId && el.index === o.index)}
                                                            style={{zoom: "1.5"}}
                                                            onClick={(e) => e.stopPropagation()}
                                                            onChange={(e) => handleSelectionChange(e, o)}
                                                        />
                                                    )}
                                                </td>
                                                <td>{o["documentType"]}<br/>{moment(o["created_at"]).format("DD/MM/YYYY HH:mm")}</td>
                                                <td>{o["month"]}</td>
                                                <td className={"file-name-cell"} title={o["fileLabel"]}>{o["fileLabel"]}</td>
                                                <td>{renderExtraData(o)}</td>
                                                <td>{renderClientSupplier(o)}</td>
                                                <td className={`status-td ${formatAIDocumentColor(o["erp_status"])}`} style={{fontWeight: "600", letterSpacing: "0.3px", borderRadius: "6px"}}>
                                                    {formatAIDocumentStatus(o["erp_status"], false,  o["invoiceType"] === "17.1", !!o.isBatchSettlement || !!o.isPrepaidStatement)}
                                                    {([-121, -123].includes(o?.erp_status) && o?.erp_nonReadableReason) && (
                                                        <span><br/>{o.erp_nonReadableReason}</span>
                                                    )}
                                                </td>
                                                <td>{o["erp_score"] || "-"} {o["erp_score"] ? "%" : ""}</td>
                                                {isAdmin && (
                                                    <td>{o["credits"]}</td>
                                                )}
                                                <td>{renderActionButtons(o)}</td>
                                            </tr>
                                        )
                                    }
                                }) : (
                                    <React.Fragment></React.Fragment>
                                )}
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                </React.Fragment>
            )}
            {showSaleModal && (
                <AISaveSaleModal
                    show={showSaleModal}
                    setShow={setShowSaleModal}
                    aiDoc={aiDoc}
                    onSave={handleSaleSave}
                    onReprocess={onReprocess}
                    onDecline={onDecline}
                />
            )}
            {showBuyModal && (
                <AISaveBuyModal
                    show={showBuyModal}
                    setShow={setShowBuyModal}
                    aiDoc={aiDoc}
                    onSave={handleSaveBuy}
                    onReprocess={onReprocess}
                    onDecline={onDecline}
                />
            )}
            {showBatchSettlementModal && (
                <AIBatchSettlementModal
                    show={showBatchSettlementModal}
                    setShow={setShowBatchSettlementModal}
                    aiDoc={aiDoc}
                    onSave={handleSaveBatchSettlement}
                    onReprocess={onReprocess}
                    onDecline={onDecline}
                />
            )}
            {showPrepaidStatementModal && (
                <AIPrepaidStatementModal
                    show={showPrepaidStatementModal}
                    setShow={setShowPrepaidStatementModal}
                    aiDoc={aiDoc}
                    onSave={handleSavePrepaidStatement}
                    onReprocess={onReprocess}
                    onDecline={onDecline}
                />
            )}
            {showReprocessModal && (
                <Modal show={showReprocessModal} onHide={() => setShowReprocessModal(false)} backdrop={"static"} dialogClassName={"modal42PercentWidth"}>
                    <Modal.Header closeButton>
                        <Modal.Title>Επαναεπεξεργασία εγγράφου</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {["Πωλήσεις", "Αγορές & Δαπάνες"].includes(aiDoc.documentType) ? (
                            <div>
                                Είσαστε σίγουροι ότι θέλετε να αποστείλετε αίτημα επανεπεξεργασίας; Η επαναεπεργασία από το Primer AI,
                                μπορεί να γίνει είτε μόνο στους χαρακτηρισμούς ή σε ολόκληρο το αρχείο.
                                Η επαναεπεξεργασία θα εκτελεστεί το συντομότερο δυνατό.
                                {aiDoc.documentType === "Αγορές & Δαπάνες" && (
                                    <div>
                                        <div style={{textAlign: "center"}} className={"border-top mt-2"}>
                                            <h6 className={"mt-2"}>Επίπεδο αυστηρότητας εκπιπτόμενου Φ.Π.Α.</h6>
                                        </div>
                                        <StatusSlider
                                            min={1}
                                            max={5}
                                            labels={vatDeductibleToleranceLabels}
                                            value={vatDeductibleSlider}
                                            onChange={(e) => setVatDeductibleSlider(e)}
                                        />
                                        <div className={"mt-2"}>
                                            Με την παραπάνω επιλογή, μπορείτε να μεταβάλλετε προσωρινά το επίπεδο αυστηρότητας εκπιπτόμενου Φ.Π.Α. .
                                            Η επιλογή ΔΕΝ θα αποθηκευτεί, και θα έχει ισχύ μόνο γι΄ αυτή την επανεπεξεργασία.<br/>
                                            <u>Η επιλογή λειτουργεί μόνο σε περίπτωση επανεπεξεργασίας χαρακτηρισμών.</u>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ) : (aiDoc?.invoiceType === "17.1") ? (
                            <div>
                                Είσαστε σίγουροι ότι θέλετε να αποστείλετε αίτημα επανεπεξεργασίας; Η επαναεπεργασία από το Primer AI,
                                μπορεί να γίνει είτε μόνο στην ανάλυση της μισθοδοσίας ή σε ολόκληρο το αρχείο.
                                Η επαναεπεξεργασία θα εκτελεστεί το συντομότερο δυνατό.
                            </div>
                        ) : (
                            <div>
                                Είσαστε σίγουροι ότι θέλετε να αποστείλετε αίτημα επανεπεξεργασίας από το Primer AI;
                                Η επαναεπεξεργασία θα εκτελεστεί το συντομότερο δυνατό.
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button size={"sm"} variant="outline-primary" onClick={() => setShowReprocessModal(false)}>
                            Κλείσιμο
                        </Button>
                        <Button size={"sm"} variant="primary" onClick={() => onReprocessDocument(aiDoc, false, true)} disabled={loadingReprocess}>
                            Επαναεπεξεργασία αρχείου {loadingReprocess && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                        </Button>
                        {["Πωλήσεις", "Αγορές & Δαπάνες"].includes(aiDoc.documentType) && (
                            <Button size={"sm"} variant="primary" onClick={() => onReprocessDocument(aiDoc, false, false)} disabled={loadingReprocess}>
                                Επαναεπεξεργασία χαρακτηρισμών {loadingReprocess && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                            </Button>
                        )}
                        {(aiDoc.invoiceType === "17.1") && (
                            <Button size={"sm"} variant="primary" onClick={() => onReprocessDocument(aiDoc, false, false)} disabled={loadingReprocess}>
                                Επαναεπεξεργασία μισθοδοσίας {loadingReprocess && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                            </Button>
                        )}
                    </Modal.Footer>
                </Modal>
            )}
            {showMassReprocessModal && (
                <Modal show={showMassReprocessModal} onHide={() => setShowMassReprocessModal(false)} backdrop={"static"} dialogClassName={"modal42PercentWidth"}>
                    <Modal.Header closeButton>
                        <Modal.Title>Επαναεπεξεργασία επιλογών</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Είσαστε σίγουροι ότι θέλετε να επαναεπεξεργαστούν όλες οι επιλογές σας;
                        Επιλέξτε αν επιθυμείτε την επαναπεξεργασία μόνο των χαρακτηρισμών ή των αρχείων εξ' ολοκλήρου.
                        Η επανεπεξεργασία χαρακτηρισμών θα πραγματοποιηθεί μόνο στα αρχεία που ανήκουν στην κατηγορία των Πωλήσεων
                        και τον Αγορών & Δαπανών και είναι δυνατή η επανεπεξεργασία χαρακτηρισμών τους.
                        <div>
                            <div style={{textAlign: "center"}} className={"border-top mt-2"}>
                                <h6 className={"mt-2"}>Επίπεδο αυστηρότητας εκπιπτόμενου Φ.Π.Α.</h6>
                            </div>
                            <StatusSlider
                                min={1}
                                max={5}
                                labels={vatDeductibleToleranceLabels}
                                value={vatDeductibleSlider}
                                onChange={(e) => setVatDeductibleSlider(e)}
                            />
                            <div className={"mt-2"}>
                                Με την παραπάνω επιλογή, μπορείτε να μεταβάλλετε προσωρινά το επίπεδο αυστηρότητας εκπιπτόμενου Φ.Π.Α. για τα παραστατικά που αποτελούν Αγορές & Δαπάνες.
                                Η επιλογή ΔΕΝ θα αποθηκευτεί, και θα έχει ισχύ μόνο γι΄ αυτή την επανεπεξεργασία.<br/>
                                <u>Η επιλογή λειτουργεί μόνο σε περίπτωση επανεπεξεργασίας χαρακτηρισμών.</u>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button size={"sm"} variant="outline-primary" onClick={() => setShowReprocessModal(false)}>
                            Κλείσιμο
                        </Button>
                        <Button size={"sm"} variant="primary" onClick={() => onMassReprocess(true)} disabled={loadingReprocess}>
                            Επαναεπεξεργασία αρχείων {loadingReprocess && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                        </Button>
                        <Button size={"sm"} variant="primary" onClick={() => onMassReprocess(false)} disabled={loadingReprocess}>
                            Επαναεπεξεργασία χαρακτηρισμών {loadingReprocess && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
            {showDeclineModal && (
                <Modal show={showDeclineModal} onHide={() => setShowDeclineModal(false)} backdrop={"static"}>
                    <Modal.Header closeButton>
                        <Modal.Title>Απόρριψη εγγράφου</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Είσαστε σίγουροι ότι θέλετε να απορρίψετε το έγγραφο που έχει δημιουργήσει το Primer AI; Υπάρχει δυνατότητα επαναδημιουργίας.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-danger" onClick={() => onDeclineDocument(aiDoc)} disabled={loadingDecline}>
                            Ναι, απόρριψη {loadingDecline && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
            <Modal show={showLogs} onHide={() => setShowLogs(false)} dialogClassName={"modal50PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Ιστορικό Αρχείου : {getFileNameFromPath(aiDoc?.filePath || "")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {aiDoc?.history?.length > 0 && (
                        <React.Fragment>
                            <table className={"simpleClassicTable mb-3"}>
                                <colgroup>
                                    <col span={1} style={{width: "30%"}}></col>
                                    <col span={1} style={{width: "40%"}}></col>
                                    <col span={1} style={{width: "30%"}}></col>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th>Ημερομηνία</th>
                                    <th>Ενέργεια</th>
                                    <th>Χρήστης</th>
                                </tr>
                                </thead>
                                <tbody>
                                {aiDoc.history.map((row, idx) => (
                                    <tr key={`fsHistory-${idx}`}>
                                        <td>{moment(row["date"]).format("DD/MM/YYYY HH:mm:ss")}</td>
                                        <td>{row["details"]}</td>
                                        <td>{row["user"]}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </React.Fragment>
                    )}
                </Modal.Body>
            </Modal>
            <Modal show={showRegisterModal} onHide={() => setShowRegisterModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Καταχώρηση αρχείου</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {!isEmpty(aiDoc) && (
                        <div>
                            Είσαστε σίγουροι ότι θέλετε να καταχωρήσετε το αρχείο {getFileNameFromPath(aiDoc.filePath)} στον φάκελο {aiDoc.documentType};
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => onRegister(aiDoc)} disabled={loadingRegister}>
                        Καταχώρηση {loadingRegister && <Spinner className={"ml-2"} animation={"border"} variant={"dark"}/>}
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={savingSomething && !showBuyModal && !showSaleModal && !massLoading} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>Γρήγορη καταχώρηση</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Γίνεται καταχώρηση, παρακαλώ περιμένετε... <Spinner size={"sm"} className={"ml-2"} animation={"border"} variant={"dark"} />
                </Modal.Body>
            </Modal>
            <Modal show={massLoading} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>Μαζική ενέργεια</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Παρακαλώ περιμένετε... <Spinner size={"sm"} className={"ml-2"} animation={"border"} variant={"dark"} />
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}

export default AIModuleFiles;
